export enum SelectedRecruiter {
  ALL_RECRUITERS_OPTION = 'ALL_RECRUITERS_OPTION',
  SCRAPED_OPENINGS_OPTION = 'SCRAPED_OPENINGS_OPTION',
}
